"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiRadio = getMuiRadio;
function getMuiRadio() {
  return {
    // styles moved to radio component in ui-lib due to check-circle variant
  };
}